const baseUrl = 'https://fundnest.bands-erp.in/api';
// const baseUrl = 'http://localhost/api';

export default baseUrl;
